{
  "schemaVersion": "cogo.document-template-flow-page.v1",
  "layoutId": "reb-report.flow-page-reb-report.v1",
  "familyId": "reb-report",
  "variantId": "flow-page-reb-report",
  "profile": "flow-page",
  "designPreset": "reb_report_five_section",
  "page": {
    "size": "letter",
    "flow": true,
    "marginInches": {
      "top": 0.75,
      "right": 0.75,
      "bottom": 0.75,
      "left": 0.75
    }
  },
  "staticContent": {
    "eyebrow": "REB REPORT TEMPLATE FAMILY",
    "title": "부동산원 보고서",
    "subtitle": "표지·목차·요약·본문·부록 5부 구성 부동산원 보고서",
    "footer": "COGO · DOCUMENT ONTOLOGY · REB REPORT V1"
  },
  "styleTokenRefs": [
    "@ds:document.reb-report.v1"
  ],
  "resolvedStyleSheet": {
    "fontFamilies": {
      "latin": "Arial",
      "eastAsia": "Noto Sans KR"
    },
    "colors": {
      "navy": "111827",
      "slate": "334155",
      "muted": "64748B",
      "line": "D7DEE8",
      "soft": "F1F5F9",
      "white": "FFFFFF"
    },
    "typeScalePt": {
      "title": 22,
      "subtitle": 10.5,
      "sectionHeading": 11.2,
      "body": 10.2,
      "tableHeader": 8.4,
      "tableBody": 8.8,
      "footer": 7.5
    },
    "spacingPt": {
      "bodyAfter": 6,
      "sectionBefore": 12,
      "sectionAfter": 5
    },
    "table": {
      "widthDxa": 9360,
      "indentDxa": 120,
      "cellMarginsDxa": {
        "top": 80,
        "right": 120,
        "bottom": 80,
        "left": 120
      }
    }
  },
  "slotBindings": [
    {
      "slotId": "cover",
      "nodeId": "flow.cover",
      "semanticRole": "cover",
      "inputBindingPath": "/cover",
      "heading": "표지",
      "slotKind": "rich-text",
      "styleTokenRefs": [
        "document.heading.section",
        "document.body.primary"
      ],
      "targetAnchors": {
        "docx": {
          "kind": "bookmark",
          "part": "word/document.xml",
          "value": "cogo_cover",
          "expectedOccurrence": 1
        }
      }
    },
    {
      "slotId": "toc",
      "nodeId": "flow.toc",
      "semanticRole": "toc",
      "inputBindingPath": "/toc",
      "heading": "목차",
      "slotKind": "table",
      "styleTokenRefs": [
        "document.heading.section",
        "document.body.primary"
      ],
      "columns": [
        {
          "key": "label",
          "label": "항목",
          "widthRatio": 0.82
        },
        {
          "key": "pageRef",
          "label": "쪽",
          "widthRatio": 0.18
        }
      ],
      "targetAnchors": {
        "docx": {
          "kind": "bookmark",
          "part": "word/document.xml",
          "value": "cogo_toc",
          "expectedOccurrence": 1
        }
      }
    },
    {
      "slotId": "summary",
      "nodeId": "flow.summary",
      "semanticRole": "summary",
      "inputBindingPath": "/summary",
      "heading": "요약",
      "slotKind": "rich-text",
      "styleTokenRefs": [
        "document.heading.section",
        "document.body.primary"
      ],
      "targetAnchors": {
        "docx": {
          "kind": "bookmark",
          "part": "word/document.xml",
          "value": "cogo_summary",
          "expectedOccurrence": 1
        }
      }
    },
    {
      "slotId": "body",
      "nodeId": "flow.body",
      "semanticRole": "body",
      "inputBindingPath": "/body",
      "heading": "본문",
      "slotKind": "rich-text",
      "styleTokenRefs": [
        "document.heading.section",
        "document.body.primary"
      ],
      "targetAnchors": {
        "docx": {
          "kind": "bookmark",
          "part": "word/document.xml",
          "value": "cogo_body",
          "expectedOccurrence": 1
        }
      }
    },
    {
      "slotId": "appendix",
      "nodeId": "flow.appendix",
      "semanticRole": "appendix",
      "inputBindingPath": "/appendix",
      "heading": "부록",
      "slotKind": "rich-text",
      "styleTokenRefs": [
        "document.heading.section",
        "document.body.primary"
      ],
      "targetAnchors": {
        "docx": {
          "kind": "bookmark",
          "part": "word/document.xml",
          "value": "cogo_appendix",
          "expectedOccurrence": 1
        }
      }
    }
  ],
  "unsupportedNativePartPolicy": "preserve-or-block"
}
